import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FolderModal = ({
  onConfirm,
  onReject,
  folder = SearchResultRecord({
    name: ''
  })
}) => {
  const [folderName, setFolderName] = useState(folder.name);
  const handleNameChange = useCallback(e => {
    setFolderName(e.target.value);
  }, []);
  const confirm = useCallback(() => {
    return onConfirm(folder.set('name', folderName));
  }, [onConfirm, folder, folderName]);
  const isNew = () => {
    return !folder.contentId;
  };
  const i18nKey = isNew() ? 'new' : 'edit';
  return /*#__PURE__*/_jsx(Modal, {
    size: "auto",
    "data-selenium-test": "sales-content-index-new-folder-modal",
    children: /*#__PURE__*/_jsxs(Form, {
      onSubmit: e => {
        e.preventDefault();
        if (folderName) {
          confirm();
        }
      },
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onReject
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `salesContentIndexUI.createEditFolderModal.${i18nKey}.title`
          })
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "salesContentIndexUI.createEditFolderModal.folderLabel"
          }),
          children: /*#__PURE__*/_jsx(TextInput, {
            "data-selenium-test": "sales-content-index-new-folder-input",
            autoFocus: true
            // eslint-disable-next-line no-undefined
            ,
            value: folderName || undefined,
            onChange: handleNameChange
          })
        })
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: confirm,
          disabled: !folderName,
          "data-selenium-test": "sales-content-index-new-folder-save-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `salesContentIndexUI.createEditFolderModal.${i18nKey}.confirm`
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onReject,
          "data-selenium-test": "sales-content-index-new-folder-cancel-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "salesContentIndexUI.createEditFolderModal.cancel"
          })
        })]
      })]
    })
  });
};
export default FolderModal;